<template>
  <div v-if="data.text || data.btn_text" class="panel-collapse collapsed collapse show multi-collapse" id="turbo">
    <div id="turbo_display">
      <div 
        class="turbo_container"
        :class="wider"
      >
        <div v-if="data.text" class="turbo_text">
          <h1 class="t-parent" v-if="data" v-html="data.text" :class="data.text_color"></h1>
          <div class="t-child">
            <h1 v-if="data" v-html="data.text"></h1>
          </div>
        </div>
        <h2 v-if="data.text_more" class="turbo_text_more" v-html="data.text_more"></h2>
        <h3 v-if="data && data.btn_url" class="turbo_link">
              <a :href="data.btn_url" :class="data.btn_color">{{data.btn_text}}</a>
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "fcwpTurbo",
  props: ["data"],
  methods: {
    widthChecker() {
      this.wider = window.innerWidth > window.innerHeight ? "width" : "height";
    },
    widthCheckerReturn() {
      return window.innerWidth > window.innerHeight ? "width" : "height";
    }
  },
  data() {
    return {
      wider: this.widthChecker()
    };
  },
  mounted() {
    this.widthChecker();
  },
  created() {
    window.addEventListener("resize", this.widthChecker);
  },
  destroyed() {
    window.removeEventListener("resize", this.widthChecker);
  }
};
</script>

<style scoped lang="scss">

#turbo_display {
  display: initial;

  .turbo_container {
    position: absolute;
    bottom: 0;
    margin: 0 13vw 10vh 13vw;
    font-weight: 500;
    line-height: 1.36;
    color: rgb($septenary-color);
    z-index: 6;
  }

  .turbo_text {
    h1 {
      box-decoration-break: clone;
      -webkit-box-decoration-break: clone;
      padding: 0.1vw 1vw;
      display: inline;
    }
  }

  .turbo_text_more {
      padding: 0.1vw 1vw;
      margin-bottom: 3rem;
      text-shadow: 0 0 8px rgba(0, 0, 0, 0.8);
  }

  .t-parent {
    background: rgb($primary-color);
    color: rgb($septenary-color);
    position: relative;
  }

  .turbo_link a.primary, .t-parent.primary {
    background-color: rgb($primary-color);
  }

  .turbo_link a.secondary, .t-parent.secondary {
    background-color: rgb($secondary-color);
  }

  .turbo_link a.octonary, .t-parent.octonary {
    background-color: rgb($octonary-color);
  }

  .t-child {
    position: absolute;
    top: 0;
    left: 0;
  }

  .turbo_link {
    text-transform: uppercase;
    margin-top: calc(1vw + 10px);
  }

  .turbo_link a {
    text-decoration: none;
    color: rgb($septenary-color);
    background-color: rgb($secondary-color);
    padding: 0.3vw 0.8vw;
  }

  @media (max-width: 700px) {
    .turbo_container {
      margin-right: 18vw;
    }

    .turbo_text h1 {
      padding: 0px 10px;
    }
  }
}
</style>